/* eslint-disable no-shadow */
import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import styles from './OpenSelect.module.less';

const OpenSelect = (props) => {
  const { id, name, label, options, value, setValue, error } = props;

  const customStyles = {
    singleValue: (base) => ({ ...base, top: '70%', paddingBottom: '2px', paddingLeft: '2px' }),
    valueContainer: (base) => ({ ...base, padding: 0 }),

    indicatorSeparator: (base) => ({}),
    container: (base) => ({
      ...base,
      width: props.width,
      borderBottom: 10,
    }),
    control: (base, state) => ({
      ...base,
      borderTop: state.isFocused ? 0 : 0,
      borderRight: state.isFocused ? 0 : 0,
      borderLeft: state.isFocused ? 0 : 0,
      // This line disable the blue border
      boxShadow: state.isFocused ? 0 : 0,
      separator: 0,
      borderRadius: 0,
      '&:hover': {
        borderTop: state.isFocused ? 0 : 0,
        borderRight: state.isFocused ? 0 : 0,
        borderLeft: state.isFocused ? 0 : 0,
      },
    }),
  };

  return (
    <div className={styles.fieldNameEditContainer}>
      <label htmlFor={id} className={styles.fieldNameEdit}>
        {label}
      </label>
      <Select
        className={error ? styles.fieldSelectError : styles.fieldSelect}
        id={id}
        name={name}
        type="select"
        options={options}
        value={value}
        onChange={(v) => setValue(v.value)}
        isDisabled={props.isDisabled}
        styles={customStyles}
      />
      {error ? <div className={styles.error}>{error}</div> : null}
    </div>
  );
};

OpenSelect.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.object,
  setValue: PropTypes.func,
  error: PropTypes.string,
  isDisabled: PropTypes.bool,
  width: PropTypes.string,
};

export default OpenSelect;
